import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000000;

  @supports (height: 100dvh) {
    height: 100dvh;
  }
`;

export const TopRight = styled.div`
  position: fixed;
  top: 25px;
  right: 20px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;

  @media (max-width: 600px) {
    top: auto;
    bottom: 10px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    /* flex-direction: row; */
    align-items: center;
    gap: 10px;
  }
`;

export const TopRightButtons = styled.div`
  width: 100vw;
  max-width: calc(50vw - 200px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  @media (max-width: 600px) {
    width: auto;
    max-width: none;
  }
`;

export const Web3Buttons = styled.div`
  position: fixed;
  top: 25px;
  right: 20px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1000px) {
    top: 90px;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }

  @media (max-width: 600px) {
    top: 70px;
  }
`;
